import React from "react";
import "./style.css";

const mockData = [
  {
    id: "1",
    building: "ул. Ленина, 42",
    spotId: 47,
    status: "charging",
    current: 28,
    maxCurrent: 32,
    reading: 12847,
  },
  {
    id: "2",
    building: "пр. Мира, 15",
    spotId: 12,
    status: "available",
    current: 0,
    maxCurrent: 32,
    reading: 5420,
  },
  {
    id: "3",
    building: "ул. Гагарина, 8",
    spotId: 3,
    status: "charging",
    current: 16,
    maxCurrent: 22,
    reading: 23105,
  },
];

const statusConfig = {
  available: { label: "Available", color: "#34d399" },
  charging: { label: "Charging", color: "#34d399" },
  occupied: { label: "Occupied", color: "#fbbf24" },
  error: { label: "Error", color: "#f87171" },
};

const DemoUsersV3 = () => {
  const chargingCount = mockData.filter((i) => i.status === "charging").length;
  const availableCount = mockData.filter((i) => i.status === "available").length;

  return (
    <div className="v3-wrapper">
      {/* Шапка */}
      <header className="v3-header">
        <div className="v3-header-left">
          <div className="v3-logo">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 2L2 7l10 5 10-5-10-5z" />
              <path d="M2 17l10 5 10-5" />
              <path d="M2 12l10 5 10-5" />
            </svg>
          </div>
          <h1 className="v3-title">Объект</h1>
        </div>
        <div className="v3-header-right">
          <button className="v3-icon-btn">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="3" />
              <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
            </svg>
          </button>
          <div className="v3-avatar">А</div>
        </div>
      </header>

      {/* Статус бар */}
      <div className="v3-status-bar">
        <div className="v3-status-item">
          <span className="v3-dot" style={{ background: "#34d399" }} />
          <span>{chargingCount} Charging</span>
        </div>
        <div className="v3-status-item">
          <span className="v3-dot" style={{ background: "#34d399" }} />
          <span>{availableCount} Available</span>
        </div>
      </div>

      {/* Карточки */}
      <div className="v3-list">
        {mockData.map((item) => {
          const st = statusConfig[item.status] || statusConfig.available;
          const progress = item.maxCurrent > 0 ? (item.current / item.maxCurrent) * 100 : 0;

          return (
            <div key={item.id} className="v3-card">
              {/* Верхняя строка */}
              <div className="v3-card-top">
                <div className="v3-spot">
                  <div className="v3-spot-icon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="4" y="4" width="16" height="16" rx="2" />
                      <path d="M12 2v20" />
                      <path d="M2 12h20" />
                    </svg>
                  </div>
                  <span>Место: {item.spotId}</span>
                </div>
                <div className="v3-status-badge">
                  <span className="v3-dot-sm" style={{ background: st.color }} />
                  <span>{st.label}</span>
                </div>
              </div>

              {/* Адрес */}
              <div className="v3-address">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
                <span>{item.building}</span>
              </div>

              {/* Ток */}
              <div className="v3-current">
                <span className="v3-current-label">Текущий ток</span>
                <span className="v3-current-value">
                  {item.current} / {item.maxCurrent} A
                </span>
              </div>

              {/* Прогресс бар */}
              <div className="v3-progress-bg">
                <div
                  className="v3-progress-fill"
                  style={{ width: `${progress}%` }}
                />
              </div>

              {/* Показания */}
              <div className="v3-reading">
                <span className="v3-reading-label">Показания счётчика</span>
                <span className="v3-reading-value">
                  {item.reading.toLocaleString("ru-RU")} <span className="v3-unit">kWh</span>
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DemoUsersV3;
